import { DIMENSION_CATEGORY_KEYS } from '@src/utils/dimension/dimensionCategories';

const ECO_PRESET_KEYS = {
  APP_EVENTS: 'events',
  APP_NETWORK_PERFORMANCE: 'network-performance',
  APP_USER_EXPERIENCE: 'user-experience',
  APP_ANALYZE_ALERTS: 'analyze-alerts',
  ECO_ENGAGEMENT: 'audience-engagement',
  APP_WEB_EXPERIENCE: 'web-experience',
  APP_MOBILE_EXPERIENCE: 'mobile-experience',
  USER_REACTION: 'user-reaction',
};

const AD_PRESET_KEYS = {
  AD_REACH: 'ad-reach',
  AD_PERFORMANCE: 'ad-perf',
};

const EI_PRESET_KEYS = {
  EXEC_OVERVIEW: 'exec-overview',
  EXPERIENCE_OVERVIEW: 'exp-overview',
  ENGAGEMENT_OVERVIEW: 'eng-overview',
  DEVICE_PERFORMANCE: 'device-performance',
  ERROR_ANALYSIS: 'error-analysis',
  CDN_PERFORMANCE: 'cdn-performance',
  ANALYZE_ALERTS: 'analyze-alerts',
  AD_REACH: 'ad-reach',
  AD_PERFORMANCE: 'ad-perf',
};

export const PRESET_KEYS = {
  EI: EI_PRESET_KEYS,
  AI: AD_PRESET_KEYS,
  APP: ECO_PRESET_KEYS,
};

export const PRESET_DASHBOARD_TYPE = {
  RT_DRILLDOWN_AverageRequestDuration: 'rt-drilldown-AverageRequestDuration',
  AI_ALERTS_DIAGNOSTICS_AverageRequestDuration: 'ai-alerts-diagnostics-AverageRequestDuration',
  FLOW_DRILLDOWN: 'flow-drilldown',
} as const;

export const NETWORK_BASED_PRESET_KEYS = [
  ECO_PRESET_KEYS.APP_NETWORK_PERFORMANCE,
  PRESET_DASHBOARD_TYPE.AI_ALERTS_DIAGNOSTICS_AverageRequestDuration,
  PRESET_DASHBOARD_TYPE.RT_DRILLDOWN_AverageRequestDuration,
];

export const SESSION_BASED_PRESET_KEYS = [ECO_PRESET_KEYS.APP_USER_EXPERIENCE];

export const EVENT_BASED_PRESET_KEYS = [ECO_PRESET_KEYS.APP_EVENTS];

export const NETWORK_BASED_CATEGORY_EXCLUDES = [
  DIMENSION_CATEGORY_KEYS.eco.global_tags,
  DIMENSION_CATEGORY_KEYS.eco.events,
];
